import IIconProps, { IconInfo, IconSet } from './entities/IIconProps';
import GetIconComponent from './helper/getIconComponent';

export { IconInfo, GetIconComponent, IconSet, IIconProps };
